var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},_vm._l((_vm.visibleFilters),function(filter){return _c('RegularFilterSelectorRounded',{key:filter.config.id,class:`${_vm.baseClass}__filter`,attrs:{"filter":filter},on:{"selectedValuesChange":function($event){return _vm.onFiltersSelectedValuesChange(filter, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }